import { CircularProgress } from "@mui/material";
import Flex from "@/components/Flex";
import {
  ROUTE_FALLBACK_MIN_HEIGHT,
  ROUTE_FALLBACK_SPINNER_SIZE,
} from "./router-constant";

const RouteFallback = () => (
  <Flex
    role="status"
    aria-live="polite"
    aria-label="Loading page"
    sx={{
      width: "100%",
      minHeight: ROUTE_FALLBACK_MIN_HEIGHT,
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <CircularProgress size={ROUTE_FALLBACK_SPINNER_SIZE} />
  </Flex>
);

export default RouteFallback;
